import * as React from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getAllEvetData } from "../../api/topicDataAPI";
import { ConvertOIDValueToString } from "../../utils/objectConverter";
import {
  renderAlarmm,
  renderWarningg,
  renderNormal,
} from "../node-components/alarm-history/StatusChip";
import {
  TextField,
  Button,
  Box,
  CircularProgress,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Typography, Card, CardContent, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRefreshInterval } from "../../contexts/RefreshIntervalContext";
import { exportAlarmHistory } from "../../utils/alarmHistoryExporter";
import { usePageVisibility } from "../../hooks/usePageVisibility";
import { useObjectData } from "../../hooks/useLocalStorageData";
import { formatEpoch } from "../../utils/dateUtils";
import { useSnackbar } from "../../hooks/useSnackbar";

export default function MainGridVendingEvents() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rows, setRows] = React.useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState([]);

  const EVENT_TYPE_OPTIONS = [
    { name: "POS Ünitesi", id: 5004 },
    { name: "Otomat Durumu", id: 5003 },
    { name: "Günsonu", id: 1014 },
    { name: "Kapı Durumu", id: 5010 },
    { name: "Sinyal Düzeyi", id: 5008 },
    { name: "Stok Seviyesi", id: 5009 },
    { name: "Sıcaklık", id: 5007 },
    { name: "Satış Durumu", id: 5006 },
    { name: "Nakit Üniteleri", id: 5005 },
    { name: "Bağlantı Durumu", id: 20 },
    { name: "Reversal", id: 1013 },
    { name: "Başarılı Satış", id: 1011 },
    { name: "Başarısız Satış", id: 1012 },
  ];
  const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();
  const { interval, isRunning } = useRefreshInterval();
  const isPageVisibility = usePageVisibility();
  const apiRef = useGridApiRef();

  // Use custom hook to get objectData from localStorage
  const objectData = useObjectData();

  const columns = [
    {
      field: "goToNode",
      headerName: "",
      width: 50,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={() =>
            window.open(`/vending-machines/${params.row.nid}`, "_blank")
          }
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      ),
    },
    {
      field: "status",
      headerName: t("alarmHistory.status"),
      flex: 0.3,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const alarmType = params.row.alarmType;
        if (alarmType === 2) {
          return renderAlarmm(params.value, t);
        } else if (alarmType === 1) {
          return renderWarningg(params.value, t);
        } else if (alarmType === 0) {
          return renderNormal(params.value, t);
        }
        return null;
      },
    },
    {
      field: "dsn",
      headerName: t("alarmHistory.terminalName"),
      flex: 0.4,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "date",
      headerName: t("alarmHistory.date"),
      flex: 0.5,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "eventName",
      headerName: t("alarmHistory.eventName"),
      flex: 0.3,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "value",
      headerName: t("alarmHistory.value"),
      flex: 0.3,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "description",
      headerName: t("alarmHistory.description"),
      flex: 2,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "left",
              padding: "8px 0",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
            title={params.value ?? ""}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "details",
      headerName: t("alarmHistory.details"),
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "left",
              padding: "8px 0",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
  ];

  // Tüm tenant'larda: her başlık ve hücreyi sola yasla.
  const displayColumns = columns.map((c) => ({
    ...c,
    align: "left",
    headerAlign: "left",
  }));

  const fetchHistory = useCallback(
    async (start, end, eventTypeFilter) => {
      setLoading(true);
      try {
        let startEpoch, endEpoch;

        if (end) {
          const endDateTime = new Date(end);
          endEpoch = Math.floor(endDateTime.getTime() / 1000);
        } else {
          endEpoch = Math.floor(Date.now() / 1000);
        }

        if (start) {
          const startDateTime = new Date(start);
          startEpoch = Math.floor(startDateTime.getTime() / 1000);
        } else {
          startEpoch = endEpoch - 2592000;
        }

        const selectedNames = Array.isArray(eventTypeFilter)
          ? eventTypeFilter
          : eventTypeFilter
            ? [eventTypeFilter]
            : [];
        const eventArray = EVENT_TYPE_OPTIONS.filter((opt) =>
          selectedNames.includes(opt.name),
        ).map((opt) => opt.id);

        const alarmHistory = await getAllEvetData([], {
          event: eventArray,
          start: startEpoch,
          end: endEpoch,
        });

        if (!alarmHistory || !Array.isArray(alarmHistory)) {
          setRows([]);
          return;
        }
        const filteredWithType = alarmHistory.map((item) => {
          const matchedObj = objectData.find(
            (obj) => obj.idObject === item.event,
          );
          return { ...item, type: matchedObj ? matchedObj.type : null };
        });
        const finalConverted = filteredWithType.map((item) => {
          const matchedObj = objectData.find(
            (obj) => obj.idObject === item.event,
          );
          const convertedValue = ConvertOIDValueToString(
            { Type: item.type },
            item.val,
          );
          const alarmStatusText =
            item.alarmType === 0
              ? t("nodeComponents.alarmHistory.statusNormal")
              : item.alarmType === 1
                ? t("nodeComponents.alarmHistory.statusWarning")
                : item.alarmType === 2
                  ? t("nodeComponents.alarmHistory.statusAlarm")
                  : t("nodeComponents.alarmHistory.statusUnknown");
          let description = "-";
          let detailsText = "-"; // Only OID 206
          if (
            item.diagnosticList &&
            Array.isArray(item.diagnosticList) &&
            item.diagnosticList.length > 0
          ) {
            const diags206 = item.diagnosticList.filter((d) => d.oid === 206);
            // Exclude 1001 from other diagnostics so it doesn't appear in description
            const diagsOther = item.diagnosticList.filter(
              (d) => d.oid !== 206 && d.oid !== 1001,
            );

            const detailsParts = diags206
              .map((diagnostic) => {
                const diagnosticObj = objectData.find(
                  (obj) => obj.idObject === diagnostic.oid,
                );
                if (diagnosticObj) {
                  const convertedDiagnosticValue = ConvertOIDValueToString(
                    { Type: diagnosticObj.type },
                    diagnostic.val,
                  );
                  // Show only value for OID 206
                  return `${convertedDiagnosticValue}`;
                }
                // Fallback to raw value if object not found
                return diagnostic.val != null ? String(diagnostic.val) : null;
              })
              .filter(Boolean);

            const otherParts = diagsOther
              .map((diagnostic) => {
                const diagnosticObj = objectData.find(
                  (obj) => obj.idObject === diagnostic.oid,
                );
                if (diagnosticObj) {
                  const convertedDiagnosticValue = ConvertOIDValueToString(
                    { Type: diagnosticObj.type },
                    diagnostic.val,
                  );
                  return `${diagnosticObj.name} = ${convertedDiagnosticValue}`;
                }
                return null;
              })
              .filter(Boolean);

            if (detailsParts.length > 0) {
              detailsText = detailsParts.join(" | ");
            }
            if (otherParts.length > 0) {
              // Show diagnostics inline separated by pipes instead of new lines
              description = otherParts.join(" | ");
            }
          }

          return {
            id: item._id,
            nid: item.NID,
            dsn: item.DSN || "-",
            dtype: item.DTYPE,
            eventName: matchedObj
              ? matchedObj.name
              : t("nodeComponents.alarmHistory.unknown"),
            // Reverted: use the main converted value
            value: convertedValue,
            status: alarmStatusText,
            alarmType: item.alarmType,
            description: description,
            details: detailsText,
            date: formatEpoch(item.epoch),
            recordDate: formatEpoch(item.epoch),
          };
        });
        setRows(finalConverted);
      } finally {
        setLoading(false);
      }
    },
    [t, objectData],
  );

  useEffect(() => {
    if (isRunning && isPageVisibility) {
      const intervalMs = 60000;
      fetchHistory(startDate, endDate, selectedEventType);
      const intervalId = setInterval(
        () => fetchHistory(startDate, endDate, selectedEventType),
        intervalMs,
      );
      return () => clearInterval(intervalId);
    }
  }, [fetchHistory, isRunning, interval, isPageVisibility, selectedEventType]);

  const handleFilterClick = () => {
    fetchHistory(startDate, endDate, selectedEventType);
  };

  const handleExportToExcel = () => {
    try {
      const result = exportAlarmHistory(rows, columns, "all");

      if (result.success) {
        showSnackbar(
          t("nodeComponents.alarmHistory.exportSuccess", {
            fileName: result.fileName,
          }),
          "success",
        );
      } else {
        showSnackbar(
          result.error || t("nodeComponents.alarmHistory.exportError"),
          "error",
        );
      }
    } catch (error) {
      console.error("Excel export error:", error);
      showSnackbar(t("nodeComponents.alarmHistory.downloadError"), "error");
    }
  };

  return (
    <>
      <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
        <Card
          sx={{
            height: "100%",
            mt: 2,
            mb: 2,
            borderWidth: 2,
            borderStyle: "solid",
          }}
        >
          {" "}
          <CardContent>
            <Stack
              direction={{ xs: "column", sm: "column", md: "row" }}
              spacing={2}
              alignItems={{ xs: "flex-start", md: "center" }}
            >
              <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                {" "}
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  sx={{
                    fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem" },
                    mb: { xs: 2, md: 0 },
                    marginLeft: { xs: 0, md: 33 },
                  }}
                >
                  {t("menu.vending-events")}
                </Typography>
              </Box>
              <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }} />
              <Stack
                direction={{ xs: "column", sm: "column", md: "row" }}
                spacing={2}
                alignItems={{ xs: "stretch", md: "center" }}
                width={{ xs: "100%", md: "auto" }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  width="100%"
                  justifyContent="space-between"
                >
                  <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
                    <TextField
                      label={t("nodeComponents.alarmHistory.startDate")}
                      type="datetime-local"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      fullWidth
                    />
                  </Box>
                  <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
                    <TextField
                      label={t("nodeComponents.alarmHistory.endDate")}
                      type="datetime-local"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      fullWidth
                    />
                  </Box>
                </Stack>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  width={{ xs: "100%", sm: "auto" }}
                >
                  <Button
                    variant="contained"
                    color="third"
                    onClick={handleFilterClick}
                    startIcon={<FilterAltIcon />}
                    sx={{
                      height: 40,
                      flexGrow: { xs: 1, sm: 0 },
                    }}
                    disabled={loading}
                  >
                    {t("nodeComponents.alarmHistory.filter")}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() =>
                      fetchHistory(startDate, endDate, selectedEventType)
                    }
                    startIcon={
                      loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <RefreshIcon />
                      )
                    }
                    sx={{
                      height: 40,
                      flexGrow: { xs: 1, sm: 0 },
                      minWidth: 140,
                    }}
                    disabled={loading}
                  >
                    {t("nodeComponents.alarmHistory.refresh")}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleExportToExcel}
                    startIcon={<FileDownloadIcon />}
                    sx={{
                      height: 40,
                      flexGrow: { xs: 1 },
                      minWidth: 150,
                    }}
                    disabled={loading}
                  >
                    {t("nodeComponents.alarmHistory.export", {
                      defaultValue: "Export",
                    })}
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>
      <Box
        sx={{
          width: "100%",
          maxWidth: { sm: "100%", md: "1700px" },
          mt: 2,
          mb: 1,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 300, maxWidth: 500 }}>
          <InputLabel id="event-type-filter-label">
            {t("nodeComponents.alarmHistory.eventType") || "Olay Tipi"}
          </InputLabel>
          <Select
            labelId="event-type-filter-label"
            multiple
            value={selectedEventType}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedEventType(
                typeof value === "string" ? value.split(",") : value,
              );
            }}
            input={
              <OutlinedInput
                label={t("nodeComponents.alarmHistory.eventType") || "Olay Tipi"}
              />
            }
            renderValue={(selected) =>
              selected.length === 0
                ? t("nodeComponents.alarmHistory.allEvents") || "Tümü"
                : selected.join(", ")
            }
            MenuProps={{
              PaperProps: {
                style: { maxHeight: 300 },
              },
            }}
          >
            {EVENT_TYPE_OPTIONS.map((option) => (
              <MenuItem key={option.id} value={option.name}>
                <Checkbox
                  checked={selectedEventType.indexOf(option.name) > -1}
                />
                <ListItemText primary={option.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>{" "}
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          "& .MuiDataGrid-root": {
            minWidth: "800px",
          },
        }}
      >
        {" "}
        <DataGrid
          columns={displayColumns}
          rows={rows}
          apiRef={apiRef}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
          loading={loading}
          disableSelectionOnClick
          rowHeight={80}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              textAlign: "center",
              width: "100%",
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              lineHeight: "normal",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              display: "flex",
              padding: "8px",
            },
            "& .MuiDataGrid-columnHeader": {
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            },
            "& .MuiDataGrid-cellContent": {
              margin: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        />
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={hideSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
